"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const CustomLabelCard_1 = __importDefault(require("../CustomLabelCard"));
const DefaultLabelCard_1 = __importDefault(require("../DefaultLabelCard"));
const GroupLabelCard_1 = __importDefault(require("../GroupLabelCard"));
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const device_1 = require("@completeanatomy/device");
const ui_1 = require("@completeanatomy/ui");
// eslint-disable-next-line max-lines-per-function
function LabelsCards({ labels, currentStateIndex, selectedToolType, expandedLabelID, setExpandedLabelID, setUpdatePosition, isAddingLabels, setShowLabelLines, trigger, setOffsetChanged, }) {
    const editable = [
        bridge_schema_1.ToolType.Labels,
        bridge_schema_1.ToolType.LabelsLeft,
        bridge_schema_1.ToolType.LabelsRight,
    ].includes(selectedToolType);
    const { isMobile } = (0, device_1.usePlatform)();
    const isLandscape = (0, ui_1.useOrientation)();
    if (!(labels === null || labels === void 0 ? void 0 : labels.length)) {
        return null;
    }
    const renderLabel = ({ identifier, type, text, object, parts, position, modelPosition, }) => {
        if (expandedLabelID && expandedLabelID !== identifier) {
            return null;
        }
        if (type === bridge_schema_1.LabelType.Default && object) {
            const { name, latinName, info } = object;
            return ((0, jsx_runtime_1.jsx)(DefaultLabelCard_1.default, { identifier: identifier, defaultPosition: position, title: name, subtitle: latinName || '', description: info || '', locked: modelPosition !== currentStateIndex, selectedToolType: selectedToolType, onExpanded: setExpandedLabelID, setUpdatePosition: setUpdatePosition, "data-e2e": 'LabelsCards_DefaultLabelCard' }, identifier));
        }
        if (type === bridge_schema_1.LabelType.Custom && text !== undefined) {
            return ((0, jsx_runtime_1.jsx)(CustomLabelCard_1.default, { identifier: identifier, defaultPosition: position, text: text, locked: modelPosition !== currentStateIndex, selectedToolType: selectedToolType, editable: editable, trigger: trigger, setOffsetChanged: setOffsetChanged, setShowLabelLines: setShowLabelLines, "data-e2e": 'LabelsCards_CustomLabelCard' }, identifier));
        }
        if (type === bridge_schema_1.LabelType.Group && text !== undefined) {
            return ((0, jsx_runtime_1.jsx)(GroupLabelCard_1.default, { identifier: identifier, defaultPosition: position, text: text, parts: parts, locked: modelPosition !== currentStateIndex, selectedToolType: selectedToolType, isAddingLabels: isAddingLabels, setShowLabelLines: setShowLabelLines, setOffsetChanged: setOffsetChanged, onExpanded: setExpandedLabelID, editable: editable, "data-e2e": 'LabelsCards_GroupLabelCard' }, identifier));
        }
        return null;
    };
    if (isMobile && isLandscape) {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(MobileLeftContainer, { "data-e2e": 'LabelsCards_MobileLeftContainer', children: labels === null || labels === void 0 ? void 0 : labels.filter(label => label.position.x < 0.5).map(renderLabel) }), (0, jsx_runtime_1.jsx)(MobileRightContainer, { "data-e2e": 'LabelsCards_MobileRightContainer', children: labels === null || labels === void 0 ? void 0 : labels.filter(label => label.position.x >= 0.5).map(renderLabel) })] }));
    }
    return (0, jsx_runtime_1.jsx)(Container, { "data-e2e": 'LabelsCards_Container', children: labels === null || labels === void 0 ? void 0 : labels.map(renderLabel) });
}
exports.default = LabelsCards;
const Container = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 0;

  width: 100vw;
  height: 100vh;

  user-select: none;

  ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
    position: fixed;
    top: auto;
    bottom: 0;
    height: auto;
    max-height: 40vh;
    background: ${({ theme }) => theme.backgroundSecondary};
    padding: 16px;
    box-sizing: border-box;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    gap: 12px;
    z-index: 10;
    padding-bottom: 12em;
    user-select: auto;

    pointer-events: all;
  `)}
`;
const MobileLeftContainer = styled_components_1.default.div `
  position: absolute;
  left: 10px;
  top: 50px;
  width: 200px;
  user-select: auto;
`;
const MobileRightContainer = styled_components_1.default.div `
  position: absolute;
  right: 10px;
  top: 50px;
  width: 200px;
  user-select: auto;
`;
